import { useMemo } from 'react';
import { preFixImgUrl } from '@/utils';

export type CouponQuickLinkItem =
  | { key: string; iconImg: string; to: string }
  | { key: string; iconImg: string; href: string };

const COUPON_LIST_QUICK_LINKS = [
  {
    key: '00a5d8ee',
    iconFile: 'e62cca86d301cb431507da5775a49803.png',
    to: '/items',
  },
  {
    key: '487853f3',
    iconFile: '604ce17e39d715e03b02aba7b3874804.png',
    to: '/coupon-precautions',
  },
  {
    key: '2c7782ea',
    iconFile: '691e96c40a4369e0f941c4b9fdf709da.png',
    href: 'mailto:info.japanmall@jdxjp.net',
  },
] as const;

export default function useModel() {
  const quickLinks = useMemo<CouponQuickLinkItem[]>(
    () =>
      COUPON_LIST_QUICK_LINKS.map((row) => {
        const base = {
          key: row.key,
          iconImg: preFixImgUrl(row.iconFile),
        };
        if ('href' in row) {
          return { ...base, href: row.href };
        }
        return { ...base, to: row.to };
      }),
    [],
  );

  return { quickLinks };
}
